// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".realSendReceiveDialog .el-dialog__body {\n  padding: 10px 20px !important;\n}\n.redLabel .el-form-item__label {\n  color: rgba(203, 12, 41, 0.98) !important;\n}\n", ""]);
// Exports
module.exports = exports;
